<template>
  <div class="map-container">
    <v-row class="ma-0 pa-0" justify="end">
      <v-col cols="12" class="pa-0">
        <div id="map"></div>
      </v-col>
      <div class="board-container">
        <div class="board-item">
          <div class="board-item--icon">
            <img src="../../assets/car_empty.svg" class="board-item--icon" @click="onClickMarkerFilter('e')"
                 :style="[getEmptyIconStyle, getImageStyle]">
          </div>
          <div class="board-item--title">
            <div class="board-item--title--text">
              <div class="title1">기사</div>
              <div class="title2">빈차</div>
            </div>
          </div>
          <div class="board-item--value">{{ counts.empty }}</div>
        </div>
        <div class="board-item">
          <div class="board-item--icon">
            <img src="../../assets/car_work.svg" class="board-item--icon" @click="onClickMarkerFilter('w')"
                 :style="[getWorkIconStyle, getImageStyle]">
          </div>
          <div class="board-item--title">
            <div class="board-item--title--text">
              <div class="title1">기사</div>
              <div class="title2">주행</div>
            </div>
          </div>
          <div class="board-item--value">{{ counts.work }}</div>
        </div>
        <div class="board-item">
          <div class="board-item--icon">
            <img src="../../assets/car_rest.svg" class="board-item--icon" @click="onClickMarkerFilter('r')"
                 :style="[getRestIconStyle, getImageStyle]">
          </div>
          <div class="board-item--title">
            <div class="board-item--title--text">
              <div class="title1">기사</div>
              <div class="title2">휴식시간</div>
            </div>
          </div>
          <div class="board-item--value">{{ counts.rest }}</div>
        </div>
      </div>
    </v-row>
    <div class="driver_list_container">
      <div class="driver_list_item">
        <div class="search_bar">
          <v-text-field outlined
                        label="기사 이름 검색"
                        prepend-inner-icon="search"
                        dense
                        v-model="searchKeyword"
          />
        </div>
        <div class="driver_table_div">
          <table class="driver_table">
            <thead>
            <th style="width: 130px;">기사</th>
            <th>상태</th>
            <th>통신</th>
            </thead>
            <tbody>
              <tr v-for="item in searchByKeyword"
                  :key="item.driverId" class="driver_list_row"
                  @click.prevent="focusMakerDialog(item)"
              >
                <td class="text-center">
                  {{ item.driverName }}
                </td>
                <td class="text-center">
                  <span :class="setColor(item.status)">{{ getDriverStatus(item.status) }}</span>
                </td>
                <td class="text-center" @mouseover="onAppStatusDialog($event, item)" @mouseleave="offAppStatusDialog">
                  <v-icon
                      :color="setAppStatusColor(item)"
                      style="font-size: 20px;"
                  >fiber_manual_record</v-icon>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div id="tooltip">
      <!-- appStatus tooltip contents -->
    </div>
  </div>

</template>
<script>
export default {
  data: () => ({
    //naver map object
    map: null,
    mapOptions: {},
    mapZoom: 13,
    initLayers: ['BACKGROUND', 'BACKGROUND_DETAIL', 'POI_KOREAN', 'TRANSIT'],
    naverMapBound: {north: null, south: null, west: null, east: null},
    initFitBound: true,
    counts: {rest: 0, empty: 0, work: 0},

    //naver map events
    mapEvents: [],

    //all marker object array
    markers: [],
    markerFilters: ["r", "e", "w"],
    locations: {"r": [], "e": [], "w": [], "etc":[]},
    regions: [],

    //request timer, delay
    reqTimer: null,
    reqTimerDelay: 5000,

    //board Info
    restIconColor: '#2b95fd',
    emptyIconColor: '#cb5656',
    workIconColor: '#ebb010',

    //
    infoWindow: null,
    markerInfoWindowClickEvent: null,

    // driver list
    driverTableHeaders: [
      {
        text: '기사',
        value: 'driverName',
        align: 'center',
        sortable: false,
      },
      {
        text: '상태',
        value: 'status',
        align: 'center',
        sortable: false,
      },
      {
        text: '통신',
        value: 'appStatus',
        align: 'right',
        sortable: false,
      },
    ],
    expanded: [],
    driverList: [],
    vehicleMap: {},
    searchKeyword: '',
    normalList: [],
    obdAbnormalList: [],
    gpsAbnormalList: [],
    offList: [],

    tooltipFlag: null,


  }),
  computed: {
    getMapWidth() {
      return window.innerWidth;
    },
    getMapHeight() {
      return window.innerHeight - 64;
    },
    getRestIconStyle() {
      return {backgroundColor: this.restIconColor};
    },
    getEmptyIconStyle() {
      return {backgroundColor: this.emptyIconColor};
    },
    getWorkIconStyle() {
      return {backgroundColor: this.workIconColor};
    },
    getImageStyle() {
      return {display: 'inline', padding: '10px'};
    },
    searchByKeyword() {
      const result = this.driverList.filter(item => item.driverName.indexOf(this.searchKeyword) > -1);
      this.tooltipFlag = new Array(result.length).fill(false);
      return result;
    },
  },
  methods: {
    async reqGetReservationInfo(marker, data) {
      try {
        if (!marker.reservationId) {
          this.updateDriverInfoWindowContent("e", data, marker);
          return;
        }

        try {
          const res = await this.$api.getDrivingReservation(marker.driverId, marker.reservationId);
          if (res.data == null) {
            this.updateDriverInfoWindowContent("e", data, marker);
            return;
          }

          this.updateDriverInfoWindowContent('w', res.data, marker);
        } catch (err) {
          console.error(err)
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqGetReservationInfo'});
      }
    },
    async reqGetDriverInfo(marker, type) {
      try {
        const res = await this.$api.getDriver(marker.driverId);
        this.updateDriverInfoWindowContent(type, res.data, marker);
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqGetDriverInfo'});
      }
    },
    async reqGetMonitoringInfo() {
      try {
        const res = await this.$api.getMapMonitoringInfo();
        const {rest, empty, work, off, etc} = res.data;

        this.locations["r"] = rest;
        this.locations["e"] = empty;
        this.locations["w"] = work;
        this.locations["o"] = off;
        this.locations["etc"] = etc;

        this.counts.rest = rest.length;
        this.counts.empty = empty.length + etc.length;
        this.counts.work = work.length;

        // make normal, abnormal list
        let exceptOffList = rest.concat(empty, work, etc);
        await this.processDataList(exceptOffList);
        await this.makeDriverList();
        await this.makeVehicleMap();

        if (this.initFitBound) {
          this.naverMapBound = {north: null, south: null, west: null, east: null};
          for (let i = 0; i < rest.length; i++) {
            this.arrangeNaverMapBound(rest[i].lat, rest[i].lng);
          }

          for (let i = 0; i < empty.length; i++) {
            this.arrangeNaverMapBound(empty[i].lat, empty[i].lng);
          }

          for (let i = 0; i < work.length; i++) {
            this.arrangeNaverMapBound(work[i].lat, work[i].lng);
          }

          this.fitNaverMapBound();
          this.initFitBound = false;
        }

        this.displayDriverMarkers();

        // request polling
        this.reqTimer = window.setTimeout(() => {
          window.clearTimeout(this.reqTimer);
          this.reqGetMonitoringInfo();
        }, this.reqTimerDelay);

      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqGetMonitoringInfo'});
      }
    },
    onChangeZoom(zoom) { // change marker size by zoom
      this.mapZoom = zoom;

      this.displayDriverMarkers();

      this.closeInfoWindow();
    },
    displayDriverMarkers() {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
      this.regions = [];

      if (this.mapZoom < 15) {
        this.displaySummaryDriverMarkers();
      } else {
        this.displayDetailDriverMarkers();
      }
    },
    displayDetailDriverMarkers() {
      let targets = ["r", "e", "w"];
      for (let j = 0; j < targets.length; j++) {
        let target = targets[j];

        if (this.markerFilters.indexOf(target) > -1) {
          for (let i = 0; i < this.locations[target].length; i++) {
            this.markers.push(this.createMarker(this.locations[target][i], target));
          }
        }
      }
    },
    displaySummaryDriverMarkers() {
      let targets = ["r", "e", "w"];
      this.naverMapBound = {north: null, south: null, west: null, east: null};
      for (let j = 0; j < targets.length; j++) {
        let target = targets[j];

        for (let i = 0; i < this.locations[target].length; i++) {
          this.arrangeNaverMapBound(this.locations[target][i].lat, this.locations[target][i].lng);
        }
      }

      // 클러스터링에 필요한 기본 격자값들을 구한다.
      // lat0, lng0를 원점으로 하는 가상의 x,y
      // latUnit, lngUnit - 격자 1개의 거리
      // latUnitCount, lngUnitCount - 격자 갯수
      let latUnit = this.mapZoom == 14 ? 0.015 : this.mapZoom == 13 ? 0.015 : this.mapZoom == 12 ? 0.030 : 0.060;
      let lngUnit = this.mapZoom == 14 ? 0.020 : this.mapZoom == 13 ? 0.020 : this.mapZoom == 12 ? 0.040 : 0.080;
      let lat0 = this.naverMapBound.south - latUnit;
      let lng0 = this.naverMapBound.west - lngUnit;
      let lat1 = this.naverMapBound.north + latUnit;
      let lng1 = this.naverMapBound.east + lngUnit;
      let latUnitCount = Math.ceil((lat1 - lat0) / latUnit);
      let lngUnitCount = Math.ceil((lng1 - lng0) / lngUnit);

      // 위치 정보를 클러스터링 데이터에 담는다
      for (let j = 0; j < targets.length; j++) {
        let target = targets[j];

        if (this.markerFilters.indexOf(target) > -1) {
          for (let i = 0; i < this.locations[target].length; i++) {
            // lat0, lat0를 기준으로 0:(0,0), 1:(1,0), 2:(2,0), ... 와 같이 regionIdx를 설정한다.
            let item = this.locations[target][i];
            let latIdx = Math.floor((item.lat - lat0) / latUnit);
            let lngIdx = Math.floor((item.lng - lng0) / lngUnit);
            let regionIdx = latIdx * lngUnitCount + lngIdx;

            if (!this.regions[regionIdx]) {
              this.regions[regionIdx] = {r: 0, e: 0, w: 0, total: 0, latSum: 0, lngSum: 0, lat: 0, lng: 0, nears: []};
            }

            this.regions[regionIdx][target]++;
            this.regions[regionIdx].total++;
            this.regions[regionIdx].latSum += item.lat;
            this.regions[regionIdx].lngSum += item.lng;
          }
        }
      }

      // region의 중간 좌표를 구한다.
      for (let i in this.regions) {
        let region = this.regions[i];
        if (region.total) {
          region.lat = region.latSum / region.total;
          region.lng = region.lngSum / region.total;
        }
      }

      let mergeRegions = [[], [], [], [], []];

      // 이웃하는 region과 통합이 가능한 region을 찾는다.
      for (let i in this.regions) {
        i = parseInt(i);
        let region = this.regions[i];
        let nears = [i - lngUnitCount - 1, i - lngUnitCount, i - lngUnitCount + 1, i - 1, i + 1, i + lngUnitCount - 1, i + lngUnitCount, i + lngUnitCount + 1];
        let isExists = false;

        for (let j in nears) {
          let i2 = nears[j];

          if (this.regions[i2]) {
            let region2 = this.regions[i2];
            if (2 * Math.abs(region.lat - region2.lat) < latUnit && 2 * Math.abs(region.lng - region2.lng) < lngUnit) {
              region.nears.push(i2);
            }
          }
        }

        if (region.nears.length) {
          for (let j = 0; j < mergeRegions.length; j++) {
            if (j >= region.nears.length) {
              for (let k = 0; k < region.nears.length; k++) {
                let mergeIdx = mergeRegions[j].indexOf(region.nears[k]);
                if (mergeIdx != -1) {
                  isExists = true;
                  break;
                }
              }
            } else {
              for (let k = 0; k < region.nears.length; k++) {
                let mergeIdx = mergeRegions[j].indexOf(region.nears[k]);
                if (mergeIdx != -1) {
                  mergeRegions[j][mergeIdx] = -1;
                }
              }
            }
          }

          if (!isExists) {
            mergeRegions[region.nears.length].push(parseInt(i));
          }
        }
      }

      // 이웃하는 region 데이터 통합
      for (let i = 0; i < mergeRegions.length; i++) {
        for (let j = 0; j < mergeRegions[i].length; j++) {
          if (mergeRegions[i][j] > -1) {
            let region = this.regions[mergeRegions[i][j]];
            this.regions[mergeRegions[i][j]] = null;

            for (let k = 0; k < region.nears.length; k++) {
              let region2 = this.regions[region.nears[k]];
              region.r += region2.r;
              region.e += region2.e;
              region.w += region2.w;
              region.total += region2.total;
              region.latSum += region2.latSum;
              region.lngSum += region2.lngSum;
              this.regions[region.nears[k]] = null;
            }
            region.lat = region.latSum / region.total;
            region.lng = region.lngSum / region.total;

            let newLatIdx = Math.floor((region.lat - lat0) / latUnit);
            let newLngIdx = Math.floor((region.lng - lng0) / lngUnit);
            let newRegionIdx = newLatIdx * lngUnitCount + newLngIdx;

            this.regions[newRegionIdx] = region;
          }
        }
      }

      // region data를 화면에 표시한다.
      for (let i in this.regions) {
        let region = this.regions[i];
        if (region && region.total) {
          let regionSize = 20;
          let regionClass = "small";

          switch (this.mapZoom) {
            case 11 :
              regionSize = region.total < 20 ? 20 : region.total < 50 ? 30 : 40;
              regionClass = region.total < 20 ? "small" : region.total < 50 ? "medium" : "large";
              break;
            case 12 :
              regionSize = region.total < 10 ? 20 : region.total < 20 ? 30 : 40;
              regionClass = region.total < 10 ? "small" : region.total < 20 ? "medium" : "large";
              break;
            case 13 :
              regionSize = region.total < 5 ? 20 : region.total < 10 ? 30 : 40;
              regionClass = region.total < 5 ? "small" : region.total < 10 ? "medium" : "large";
              break;
            case 14 :
              regionSize = region.total < 3 ? 20 : region.total < 5 ? 30 : 40;
              regionClass = region.total < 3 ? "small" : region.total < 5 ? "medium" : "large";
              break;
          }

          let marker = new naver.maps.Marker({
            position: new naver.maps.LatLng(region.lat, region.lng),
            map: this.map,
            icon: {
              size: new naver.maps.Size(2 * regionSize, 2 * regionSize),
              anchor: new naver.maps.Point(regionSize, regionSize),
              content: '<div class="regionArea ' + regionClass + '">' + region.total + '</div>'
            },
            regionData: region
          });

          this.markers.push(marker);

          naver.maps.Event.addListener(marker, 'click', this.showSummaryDriverInfo(marker, region));
        }
      }
    },
    onClickMarkerFilter(target) {
      const idx = this.markerFilters.indexOf(target);
      if (idx > -1) {
        this.markerFilters.splice(idx, 1);
        switch (target) {
          case "r" :
            this.restIconColor = "#aaaaaa";
            break;
          case "e" :
            this.emptyIconColor = "#aaaaaa";
            break;
          case "w" :
            this.workIconColor = "#aaaaaa";
            break;
        }
      } else {
        this.markerFilters.push(target);
        switch (target) {
          case "r" :
            this.restIconColor = "#2b95fd";
            break;
          case "e" :
            this.emptyIconColor = "#cb5656";
            break;
          case "w" :
            this.workIconColor = "#ebb010";
            break;
        }
      }
      this.displayDriverMarkers();
    },

    createMarker(info, type) {
      // TODO AppStatus를 marker를 통해 reqGetResrv와 reqGetDriver에서 받을 수 있도록 한다.
      const {driverId, vehicleId, reservationId, direction, lat, lng, status, obdStatus, gpsStatus} = info;
      const vehicleInfo = this.vehicleMap[vehicleId];
      const vehiclePlateNo = vehicleInfo && vehicleInfo.plateNo;
      let obdMsg = obdStatus ? '' : ' OBD 미연결 ';
      let gpsMsg = gpsStatus ? '' : ' GPS 수신 이상 ';

      let vueRoot = this;
      let marker = new naver.maps.Marker({
        driverId, vehicleId,
        reservationId,
        direction,
        lat, lng,
        status,
        position: new naver.maps.LatLng(lat, lng),
        draggable: false,
        icon: this.getWorkIcon({ ...info, vehiclePlateNo }),
        map: this.map,
        appStatus: obdStatus && gpsStatus ? '정상' : (obdStatus || gpsStatus ? obdMsg.concat(gpsMsg) : obdMsg.concat(',', gpsMsg)),
      });

      if (type == "w") {
        naver.maps.Event.addListener(marker, 'click', function () {
          vueRoot.reqGetReservationInfo(marker);
        });
      } else {
        naver.maps.Event.addListener(marker, 'click', function () {
          vueRoot.reqGetDriverInfo(marker, type);
        });
      }

      return marker;
    },
    getWorkIcon({ direction, status, driverName, vehiclePlateNo }) { // create driver icon
      let size = 8;
      let fontSize = 8;
      let image = require("../../assets/car_unknown.png");
      switch (this.mapZoom) {
        case 17:
          size = 24;
          fontSize = 14;
          break;
        case 16:
          size = 14;
          fontSize = 12
          break;
        case 15:
          size = 8;
          fontSize = 8;
          break;
      }

      switch (status) {
        case "rest" :
          image = require("../../assets/car_rest.png");
          break;
        case "empty" :
          image = require("../../assets/car_empty.png");
          break;
        case "work" :
          image = require("../../assets/car_work.png");
          break;
      }

      return {
        // direction,
        content: `<div class="car-marker">
                    <img src="${image}" style="width:${2 * size}px; transform: rotate( ${direction}deg );">
                    <span class="car-marker--plate-no" style="font-size:${fontSize}px">${vehiclePlateNo ? vehiclePlateNo : '-'}</span>
                    <span class="car-marker--driver-name"style="font-size:${fontSize}px">${driverName}</span>
                  </div>`,
        size: new naver.maps.Size(2 * size, 2 * size),
        scaledSize: new naver.maps.Size(2 * size, 2 * size),
        anchor: new naver.maps.Point(size, size)
      };
    },
    openInfoWindow(target) {
      this.closeInfoWindow();
      this.infoWindow.open(this.map, target);
    },
    closeInfoWindow() {
      if (this.infoWindow && this.infoWindow.getMap()) {
        this.infoWindow.close();
      }
    },
    showSummaryDriverInfo(marker, region) {
      let vueRoot = this;
      return function () {
        const contentString = [
          '<div id="infoWindow">',
          '  <div id="summaryInfoBox">',
          '    <div class="summaryInfoBox">',
          '      <div id="infoWindowClassButton" class="closeButton">',
          '        <img src="', require("../../assets/ico_close.png"), '">',
          '      </div>',
          '      <div class="line">',
          '        <div class="name">기사(빈차)</div>',
          '        <div class="value empty">' + region.e + '</div>',
          '      </div>',
          '      <div class="line">',
          '        <div class="name">기사(주행)</div>',
          '        <div class="value work">' + region.w + '</div>',
          '      </div>',
          '      <div class="line">',
          '        <div class="name">기사(휴식시간)</div>',
          '        <div class="value rest">' + region.r + '</div>',
          '      </div>',
          '    </div>',
          '  </div>',
          '</div>'
        ].join('');

        vueRoot.infoWindow.setContent(contentString);
        vueRoot.infoWindow.open(vueRoot.map, marker);

        if (!vueRoot.markerInfoWindowClickEvent) {
          setTimeout(() => {
            vueRoot.markerInfoWindowClickEvent = document.getElementById("infoWindowClassButton").addEventListener(
                'click',
                () => {
                  vueRoot.closeInfoWindow();
                });
          }, 300);
        }
      }
    },
    updateDriverInfoWindowContent(type, info, marker) {
      let driverName = '',
          vehiclePlateNo = '',
          rsvDeparture = '-',
          rsvDestination = '-',
          rsvStatus = marker.status,
          appStatus = marker.appStatus,
          vehicleId = marker.vehicleId,
          driverIdString = marker.driverId,
          rsvId = marker.reservationId,

          customerIdString = '',
          customerNameString = ''
      ;

      if (type === 'r') {
        const vehicle = this.vehicleMap[vehicleId];
        driverName = info?.driverName || '-';
        vehiclePlateNo = vehicle?.plateNo || '-';
        rsvStatus = '휴식시간';
      } else if (type === 'e') {
        const vehicle = this.vehicleMap[vehicleId];
        driverName = info?.driverName || '-';
        vehiclePlateNo = vehicle?.plateNo || '-';
        rsvStatus = '빈차';

      } else if (type === 'w') {
        driverName = info.driverName;
        vehiclePlateNo = info?.plateNo || '-';
        rsvDeparture = info.departure;
        rsvDestination = info.destination;
        rsvStatus = '주행중';

        customerIdString = info.bookerId ? info.bookerId : '';
        customerNameString = info.bookerName;
      }

      // 주행중이냐 아니냐에 따라 다른 값
      const contentString =
          (type === 'w') ?
              `<div id="infoWindow">
              <div id="driverInfoBox">
                <div class="driverInfoBox">
                  <div id="infoWindowClassButton" class="closeButton">
                    <img src="${require('../../assets/ico_close.png')}" alt="" />
                  </div>
                  <div class="line">
                    <div class="name">기사명</div>
                    <div class="value">
                      ${driverName}
                      <button id="goDriverDetail" data-driver="${driverIdString}">
                        <img class="search_icon" src="${require('../../assets/ico_magnify.png')}"/>
                      </button>
                    </div>
                  </div>
                  <div class="line">
                    <div class="name">차번호</div>
                    <div class="value">
                      ${vehiclePlateNo}
                      <button id="goVehicleDetail" data-vehicle="${vehicleId}">
                        <img class="search_icon" src="${require('../../assets/ico_magnify.png')}"/>
                      </button>
                    </div>
                  </div>
                  <div class="line">
                    <div class="name">앱 상태</div>
                    <div class="value">${appStatus}</div>
                  </div>
                  <div class="line">
                    <div class="name">상태</div>
                    <div class="value">${rsvStatus}</div>
                  </div>
                  <div class="line">
                    <div class="name">예약자</div>
                    <div class="value">
                      ${customerNameString}
                      <button id="goCustomerDetail" data-customer="${customerIdString}">
                        <img class="search_icon" src="${require('../../assets/ico_magnify.png')}"/>
                       </button>
                    </div>
                  </div>
                  <div class="line">
                    <div class="name">출발지</div>
                    <div class="value">${rsvDeparture}</div>
                  </div>
                  <div class="line">
                    <div class="name">도착지</div>
                    <div class="value">${rsvDestination}</div>
                  </div>
                  <div class="line">
                    <button id="goRsvDetail" data-reservation="${rsvId}">예약 상세 정보</button>
                  </div>
                </div>
              </div>
            </div>`
              : `<div id="infoWindow">
              <div id="driverInfoBox">
                <div class="driverInfoBox">
                  <div id="infoWindowClassButton" class="closeButton">
                    <img src="${require('../../assets/ico_close.png')}" alt="" />
                  </div>
                  <div class="line">
                    <div class="name">기사명</div>
                    <div class="value">
                      ${driverName}
                     <button id="goDriverDetail" data-driver="${driverIdString}">
                      <img class="search_icon" src="${require('../../assets/ico_magnify.png')}"/>
                     </button>
                    </div>
                  </div>
                  <div class="line">
                    <div class="name">차번호</div>
                    <div class="value">
                      ${vehiclePlateNo}
                       <button id="goVehicleDetail" data-vehicle="${vehicleId}">
                        <img class="search_icon" src="${require('../../assets/ico_magnify.png')}"/>
                       </button>
                    </div>
                  </div>
                  <div class="line">
                    <div class="name">앱 상태</div>
                    <div class="value">${appStatus}</div>
                  </div>
                  <div class="line">
                    <div class="name">상태</div>
                    <div class="value">${rsvStatus}</div>
                  </div>
                </div>
              </div>
            </div>`;


      this.infoWindow.setContent(contentString);
      this.openInfoWindow(marker);

      if (!this.markerInfoWindowClickEvent) {
        setTimeout(() => {
          this.markerInfoWindowClickEvent = document.getElementById("infoWindowClassButton").addEventListener(
              'click',
              () => {
                this.closeInfoWindow();
              });
        })
      }

      // add moving page event
      setTimeout(() => {
        let driverDetail = document.getElementById("goDriverDetail");
        let vehicleDetail = document.getElementById("goVehicleDetail");
        let reservationDetail = document.getElementById("goRsvDetail");
        let customerDetail = document.getElementById("goCustomerDetail");

        driverDetail.addEventListener(
            'click',
            () => {
              this.movePage('drivers', driverDetail.dataset.driver)
            }, 300);
        vehicleDetail.addEventListener(
            'click',
            () => {
              this.movePage('vehicle', vehicleDetail.dataset.vehicle)
            }, 300);

        if (reservationDetail) {
          reservationDetail.addEventListener(
              'click',
              () => {
                this.movePage('reservation', reservationDetail.dataset.reservation)
              }, 300);
        }

        // 비회원인 경우 customerId가 없음
        if (customerIdString) {
          customerDetail.addEventListener(
              'click',
              () => {
                this.movePage('customers', customerDetail.dataset.customer)
              }, 300);
        }
      }, 500);

    },
    arrangeNaverMapBound(lat, lng) {
      if (this.naverMapBound.north == null) {
        this.naverMapBound.north = lat;
      }
      if (this.naverMapBound.south == null) {
        this.naverMapBound.south = lat;
      }
      if (this.naverMapBound.west == null) {
        this.naverMapBound.west = lng;
      }
      if (this.naverMapBound.east == null) {
        this.naverMapBound.east = lng;
      }

      this.naverMapBound.north = Math.max(this.naverMapBound.north, lat);
      this.naverMapBound.south = Math.min(this.naverMapBound.south, lat);
      this.naverMapBound.east = Math.max(this.naverMapBound.east, lng);
      this.naverMapBound.west = Math.min(this.naverMapBound.west, lng);
    },
    fitNaverMapBound() {
      if (this.naverMapBound.north && this.naverMapBound.south && this.naverMapBound.west && this.naverMapBound.east) {
        if (this.naverMapBound.north == this.naverMapBound.south && this.naverMapBound.west == this.naverMapBound.east) {
          this.map.setCenter(new naver.maps.LatLng(this.naverMapBound.south, this.naverMapBound.west));
        } else {
          var latOffset = (this.naverMapBound.north - this.naverMapBound.south) / 10;
          var lngOffset = (this.naverMapBound.east - this.naverMapBound.west) / 10;
          var sw = new naver.maps.LatLng(this.naverMapBound.south - latOffset, this.naverMapBound.west - lngOffset);
          var ne = new naver.maps.LatLng(this.naverMapBound.north + latOffset, this.naverMapBound.east + lngOffset);
          var bounds = new naver.maps.LatLngBounds(sw, ne);
          this.map.fitBounds(bounds);
        }
      }
    },
    movePage(type, pageId) {
      window.location.href = `/${type}/${pageId}`
    },
    processDataList(list){
      const normalList = [];
      const obdAbnormalList = [];
      const gpsAbnormalList = [];

      if (list.length < 1) return;
      list.map(item => {
        if (item.obdStatus && item.gpsStatus) normalList.push(item);
        else if(!item.obdStatus && item.gpsStatus) obdAbnormalList.push(item);
        else gpsAbnormalList.push(item);
      });

      this.normalList = normalList;
      this.obdAbnormalList = obdAbnormalList;
      this.gpsAbnormalList = gpsAbnormalList;
    },
    makeDriverList() {
      const offList = this.locations["o"].slice()
          .sort((a, b) => a.driverName > b.driverName ? 1 : -1)
          .map(item => {
            let newItem = {...item};
            newItem.appStatus = 'off';
            return newItem;
          });
      this.gpsAbnormalList = this.gpsAbnormalList
          .sort((a, b) => a.driverName > b.driverName ? 1 : -1)
          .map(item => {
            let newItem = {...item};
            newItem.appStatus = 'abnormal';
            return newItem;
          });
      this.obdAbnormalList = this.obdAbnormalList
          .sort((a, b) => a.driverName > b.driverName ? 1 : -1)
          .map(item => {
            let newItem = {...item};
            newItem.appStatus = 'abnormal';
            return newItem;
          });
      this.normalList = this.normalList
          .sort((a, b) => a.driverName > b.driverName ? 1 : -1)
          .map(item => {
            let newItem = {...item};
            newItem.appStatus = 'normal';
            return newItem;
          })

      // frdb이상, 이상, 정상, 퇴근자 순
      this.driverList = this.gpsAbnormalList.concat(this.obdAbnormalList, this.normalList, offList);
    },
    async makeVehicleMap() {
      const res = await this.$api.getVehicleList();
      this.vehicleMap = res.data.reduce((map, item) => {
        map[item.id] = item;
        return map;
      }, {});
    },
    getDriverStatus(data) {
      let result = '';
      switch (data) {
        case 'work':
          result = '주행';
          break;
        case 'empty':
        case 'unknown':
          result = '빈차';
          break;
        case 'rest':
          result = '휴식';
          break;
        case 'off':
          result = '퇴근';
          break;
      }
      return result;
    },
    setColor(data) {
      let color = '';
      switch (data) {
        case 'work':
          color = 'deepOrange--text';
          break;
        case 'empty':
        case 'unknown':
          color = 'red--text';
          break;
        case 'rest':
          color = 'blue--text';
          break;
        case 'off':
          color = 'light2Grey--text';
          break;
      }
      return color;
    },
    setAppStatusColor(data) {
      let color = '';
      switch (data.appStatus) {
        case 'abnormal':
          color = 'red';
          break;
        case 'normal':
          color = 'light1Green';
          break;
        case 'off':
          color = 'grey';
          break;
      }
      return color;
    },
    showAppStatusMsg(data) {
      let obdMsg = data.obdStatus ? '' : '• OBD 미연결 ';
      let gpsMsg = data.gpsStatus ? '' : '• GPS 수신 이상 ';
      return data.obdStatus && data.gpsStatus ? '' : (data.obdStatus || data.gpsStatus ? obdMsg.concat(gpsMsg) : obdMsg.concat('\n', gpsMsg));
    },
    focusMakerDialog(data){
      if (data.status === 'off' || data.status === 'unknown') return;

      let mapData = {};
      mapData['lat'] = data.lat;
      mapData['lng'] = data.lng;
      this.mapOptions = mapData;

      this.map.updateBy(new naver.maps.LatLng(this.mapOptions.lat, this.mapOptions.lng), 16)
      // this.map.setZoom(15, true)
      // this.map.panTo(new naver.maps.LatLng(this.mapOptions.lat, this.mapOptions.lng));

      // row의 lat, lng으로 markers에서 필터링
      let clickedRowsMarker = this.markers.find(item => item.lat === data.lat && item.lng === data.lng);

      // type에 따라 reqGetRersv, reqGetDriver 호출
      if (data.status === 'work') {
        this.reqGetReservationInfo(clickedRowsMarker, data);
      } else {
        let type = data.status === 'empty' ? 'e' : 'r';
        this.updateDriverInfoWindowContent(type, data, clickedRowsMarker)
        // this.reqGetDriverInfo(clickedRowsMarker, type);
      }
    },
    onAppStatusDialog(e, data) {
      // appStatus가 이상 일때만 표시
      if (data.appStatus !== 'abnormal') return;
      let tooltip = document.getElementById('tooltip');

      // set msg
      tooltip.innerText = this.showAppStatusMsg(data);

      // set position
      tooltip.style.top = `${e.clientY}px`;
      tooltip.style.left = `${e.clientX}px`;
      tooltip.style.visibility = 'visible';
    },
    offAppStatusDialog() {
      let tooltip = document.getElementById('tooltip');
      tooltip.style.visibility = 'hidden';
    }
  },

  mounted() {
    let mapData = {};

    if (this.$store.state.userInfo.centerPoint !== null) {
      let centerPoint = this.$store.state.userInfo.centerPoint;

      let commaIdx = centerPoint.indexOf(',');
      mapData['lng'] = parseFloat(centerPoint.substring(0, commaIdx));
      mapData['lat'] = parseFloat(centerPoint.substring(commaIdx + 1, centerPoint.length));
      // mapData['lng'] = parseFloat(centerPoint.toString().split('\,')[0]);
      // mapData['lat'] = parseFloat(centerPoint.toString().split('\,')[1]);
      this.mapOptions = mapData;
    } else {
      mapData['lat'] = 37.523706;
      mapData['lng'] = 126.925468;
      this.mapOptions = mapData;
    }

    // create naver map object
    this.map = new naver.maps.Map("map", {
      zoom: this.mapZoom,
      minZoom: 11,
      maxZoom: 17,
      center: new naver.maps.LatLng(this.mapOptions.lat, this.mapOptions.lng)
    });

    window.naverMap = this.map;
    naver.maps.Event.once(naverMap, 'init_stylemap', function () {
      try {
        var rightBottomControlHtml = '<div style="width : 10px; height : 30px;"></div>';
        var rightBottomControl = new naver.maps.CustomControl(rightBottomControlHtml, {
          position: naver.maps.Position.RIGHT_BOTTOM
        });
        var zoomControl = new naver.maps.ZoomControl({
          position: naver.maps.Position.RIGHT_BOTTOM,
          style: naver.maps.ZoomControlStyle.LARGE
        });

        rightBottomControl.setMap(naverMap);
        zoomControl.setMap(naverMap);
      } catch (err) {
        console.log(err);
      }
    });

    this.mapEvents.push(naver.maps.Event.addListener(this.map, 'zoom_changed', (zoom) => {
      this.onChangeZoom(zoom);
    }));

    //create infoWindow object
    this.infoWindow = new naver.maps.InfoWindow({
      content: '',
      backgroundColor: "rgba(0,0,0,0)",
      borderWidth: 0,
      anchorSize: new naver.maps.Size(0, 30)
    });

    //request monitoring info
    this.reqGetMonitoringInfo();
  },
  beforeDestroy() {
    window.clearTimeout(this.reqTimer);

    if (this.mapEvents && this.mapEvents.length > 0)
      naver.maps.Event.removeListener(this.mapEvents);

    this.markerInfoWindowClickEvent = null;
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  margin: -20px -20px 0px -20px;
}

#map {
  position: relative;
  width: 100%;
  height: calc(100vh - 64px);
  padding: 0;
  margin: 0;
}

.board-container {
  width: 260px;
  height: 130px;
  position: absolute;
  z-index: 5;
  top: 28px;
  right: 10px;
}

.board-item {
  width: 240px;
  height: 60px;
  background-color: white;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 10px;

  .board-item--icon {
    width: 60px;
    height: 60px;
    display: inline-block;
    background-color: grey;
    border-radius: 3px;
  }

  .board-item--title {
    width: 90px;
    height: 60px;
    display: inline-block;
    vertical-align: top;
    overflow: hidden;

    .board-item--title--text {
      color: #727589;
      height: 60px;
      padding-top: 10px;
      padding-left: 13px;
      text-align: left;
      line-height: 20px;
    }

    .board-item--title--text .title1 {
      font-size: 14px;
    }

    .board-item--title--text .title2 {
      font-size: 12px;
    }
  }

  .board-item--value {
    width: 90px;
    height: 60px;
    display: inline-block;
    font-size: 40px;
    text-align: center;
    vertical-align: top;
    overflow: hidden;
  }
}

.driver_list_container {
  position: absolute;
  top: 28px;
  left: 22px;
  z-index: 5;
  height: 90%;

  .driver_list_item {
    position: static;
    width: 290px;
    height: 100%;
    background-color: whitesmoke;
    opacity: 0.9;
    border-radius: 10px;
    padding: 10px;
  }
}

.search_bar {
  margin: 10px;
  height: 55px;
}

.driver_table_div {
  width: 270px;
  height: 87%;
  overflow-y: scroll;
}

// ----------------------------

.driver_table {
  width: 100%;
  border-collapse: collapse;
}

.driver_table th, tr {
  height: 40px;
  border-bottom: 1px solid #ddd;
}

.driver_list_row:hover {
  background-color: lightgray;
}

#tooltip {
  display: inline-block;
  visibility: hidden;
  opacity: 0.7;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  z-index: 6;
  position: fixed;
}

</style>
<style>
.regionArea {
  background-color: #00477f;
  border-radius: 100%;
  color: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.regionArea.small {
  font-size: 20px;
  width: 40px;
  height: 40px;
}

.regionArea.medium {
  font-size: 30px;
  width: 60px;
  height: 60px;
}

.regionArea.large {
  font-size: 40px;
  width: 80px;
  height: 80px;
}

#summaryInfoBox {
  width: 300px;
}

.summaryInfoBox {
  padding: 30px;
  background-color: #272b43;
  border-radius: 10px;
  opacity: 0.9;
}

.summaryInfoBox .line {
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: white;
}

.summaryInfoBox .line ~ .line {
  margin-top: 10px;
}

.summaryInfoBox .line .name {
  display: inline-block;
  width: 150px;
  border-right: 1px solid #43475d;
}

.summaryInfoBox .line .value {
  display: inline-block;
  width: 40px;
  margin-left: 10px;
  text-align: right;
}

.summaryInfoBox .closeButton {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.summaryInfoBox .closeButton img {
  width: 24px;
  height: 24px;
}

#driverInfoBox {
  width: 400px;
}

.driverInfoBox {
  padding: 20px;
  background-color: #272b43;
  border-radius: 10px;
  opacity: 0.9;
}

.driverInfoBox .line {
  word-break: break-all;
  font-size: 16px;
  color: white;
}

.driverInfoBox .line ~ .line {
  margin-top: 10px;
}

.driverInfoBox .line .name {
  width: 95px;
  display: inline-block;
}

.driverInfoBox .line .value {
  width: 240px;
  display: inline-block;
  border-left: 1px solid #43475d;
  text-align: left;
  padding-left: 15px;
  vertical-align: middle;
}

.driverInfoBox .closeButton {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.driverInfoBox .closeButton img {
  width: 24px;
  height: 24px;
}

.search_icon {
  height: 17px;
}

#goRsvDetail {
  color: white;
  width: 100%;
  height: 100%;
  border: 2px solid;
}

.car-marker {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.car-marker--plate-no {
  white-space: nowrap;
}

.car-marker--driver-name {
  white-space: nowrap;
}
</style>
